import type { SVGProps } from "react";
import * as React from "react";

const SvgChevronsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.293 11.707a1 1 0 0 0 1.414-1.414zM12 6l.707-.707a1 1 0 0 0-1.414 0zm-5.707 4.293a1 1 0 1 0 1.414 1.414zm10 8.414a1 1 0 0 0 1.414-1.414zM12 13l.707-.707a1 1 0 0 0-1.414 0zm-5.707 4.293a1 1 0 1 0 1.414 1.414zm11.414-7-5-5-1.414 1.414 5 5zm-6.414-5-5 5 1.414 1.414 5-5zm6.414 12-5-5-1.414 1.414 5 5zm-6.414-5-5 5 1.414 1.414 5-5z"
    />
  </svg>
);
export default SvgChevronsUp;
